module.exports = __webpack_public_path__ + "static/banner-06600aecb24dd00c59ac0d0222f3d5b3.svg";